export default {
  title: 'ORBRO đang tìm kiếm các đại lý để cùng vươn tới vị trí số 1 thế giới.',

  form: {
    title: 'Vui lòng kiểm tra hồ sơ cần nộp',
    docu: [
      {
        title: 'Hồ sơ yêu cầu',
        item: [
          { text: '[Bắt buộc] Hồ sơ giới thiệu công ty (lĩnh vực kinh doanh, tình hình nhân sự, v.v.)' },
          { text: '[Bắt buộc] Báo cáo đánh giá tín dụng' },
          { text: '[Bắt buộc] Kế hoạch kinh doanh (theo mẫu tự do)' },
        ],
      },
      {
        title: 'Thời gian tuyển dụng',
        item: [{ text: 'Tuyển dụng thường xuyên' }],
      },
      {
        title: 'Lưu ý khi nộp hồ sơ',
        item: [
          { text: 'Vui lòng ghi tên tệp theo định dạng dưới đây và gửi qua email.' },
          { text: 'Email: pr@orbro.io', type: '-' },
          { text: 'Định dạng tập: [Lĩnh vực hỗ trợ]Tên công ty_Tên người nhận', type: '-' },
        ],
      },
      {
        title: 'Quyền lợi',
        item: [{ text: 'Hỗ trợ kỹ thuật và đào tạo từ kỹ sư' }, { text: 'Cung cấp công cụ bán hàng (tài liệu quảng bá, v.v.)' }],
      },
    ],
  },

  requestForm: {
    title: 'Thông tin người đăng ký',
    input: [
      { label: 'Họ tên *', place_holder: 'Nguyễn Văn A', tag: 'name', type: '0' },
      { label: 'Số điện thoại *', place_holder: 'Chỉ nhập số, không dấu gạch ngang', tag: 'phone', type: '0' },
      { label: 'Tên công ty *', place_holder: 'Tên công ty hoặc doanh nghiệp', tag: 'company', type: '0' },
      { label: 'Mã số doanh nghiệp *', place_holder: 'Chỉ nhập số, không dấu gạch ngang', tag: 'registNumber', type: '0' },
      { label: 'Khu vực mong muốn kinh doanh *', place_holder: 'Chọn tỉnh/thành', tag: 'region', type: '1' },
      { label: 'Lĩnh vực ứng tuyển *', place_holder: 'Chọn lĩnh vực', tag: 'category', type: '1' },
    ],

    region: [
      { text: 'Hà Nội' },
      { text: 'Hồ Chí Minh' },
      { text: 'Đà Nẵng' },
      { text: 'Hải Phòng' },
      { text: 'Cần Thơ' },
      { text: 'An Giang' },
      { text: 'Bình Dương' },
      { text: 'Đồng Nai' },
      { text: 'Khánh Hòa' },
      { text: 'Nghệ An' },
      { text: 'Thanh Hóa' },
    ],
    category: [
      { text: 'Hệ thống quản lý ra vào' },
      { text: 'Theo dõi vị trí bằng beacon' },
      { text: 'Theo dõi vị trí thời gian thực' },
      { text: 'Theo dõi vị trí qua video' },
      { text: 'Cảm biến công nghiệp' },
      { text: 'Khác' },
    ],
  },

  file: {
    title: 'Giới thiệu công ty',
    btn: 'Thay đổi tập tin',
  },

  memo: {
    place_holder: 'Vui lòng nhập thông tin giới thiệu công ty của bạn',
  },

  alert: {
    text: 'Đính kèm/10MB hoặc ít hơn',
  },

  submit: 'Liên hệ đại lý',
};
